import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_VEHICLE_STATUS, UPDATE_VEHICLE_STATUS_SUCCESS, UPDATE_VEHICLE_STATUS_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';

function* updateVehicleStatus({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/vehicles/${payload?.id}/status`,
      method: 'PATCH',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_VEHICLE_STATUS_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_VEHICLE_STATUS_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_VEHICLE_STATUS_ERROR, payload: error });
  }
}

export function* watchUpdateVehicleStatus() {
  yield takeEvery(UPDATE_VEHICLE_STATUS, updateVehicleStatus);
}

function* updateVehicleStatusSaga() {
  yield all([fork(watchUpdateVehicleStatus)]);
}

export default updateVehicleStatusSaga;
